import {
  PanelContainer,
  SVG,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import Laurel from 'assets/caesars_laurel.svg';
import {Flex, Pressable, Text, View} from 'native-base';
import React, {useEffect, useState} from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';
import {useTheme} from 'styled-components/native';

import Checkbox from 'components/Checkbox';

export interface SubscriptionsModuleProps {
  isSubscribed: boolean;
  onSubscribedChecked?: (checked: boolean) => void;
  isDisabled?: boolean;
  isInvalid?: boolean; // set if a user is missing an email address
  setTabToProfile?: () => void;
}
const SubscriptionsModule = (props: SubscriptionsModuleProps) => {
  const theme = useTheme();
  const {
    isSubscribed,
    onSubscribedChecked,
    isDisabled,
    isInvalid,
    setTabToProfile,
  } = props;
  const isDesktop = useIsDesktop();
  const [isChecked, setIsChecked] = useState(isSubscribed);

  useEffect(() => {
    if (!isDisabled) {
      setIsChecked(isSubscribed);
    }
  }, [isSubscribed, isDisabled]);

  const handleChecked = checked => {
    if (onSubscribedChecked) {
      onSubscribedChecked(checked);
    }

    setIsChecked(checked);
  };

  return (
    <PanelContainer
      defaultOpen={false}
      icon="envelope"
      panelTitle="Subscriptions"
      contentMaxWidth={isDesktop ? undefined : '100%'}
      bodyTitle="Sign up for Caesars Rewards emails">
      <Flex flexDirection="row">
        <View mt={2}>
          <Checkbox
            accessibilityRole="checkbox"
            accessibilityLabel={`Opt into Caesars Rewards subscriptions emails.
              You are ${isSubscribed ? 'currently' : 'not'} signed up for
              subscription emails.`}
            isDisabled={isDisabled || isInvalid}
            isChecked={isChecked}
            value={'subscribed'}
            onChange={handleChecked}
          />
        </View>
        <View minW={6} />
        <Text
          flexShrink={1}
          fontSize={isDesktop ? 4 : 3}
          lineHeight={isDesktop ? '26px' : '24px'}>
          Let&apos;s stay in touch. You&apos;ll get free play coupons, offers,
          your monthly statement, and more. Please allow up to 10 business days
          for any updates to take effect.
        </Text>
      </Flex>
      {isInvalid && (
        <Flex flexDirection="row" py={isDesktop ? 6 : 4}>
          <Text color={theme.colors.error}>
            No email address on file. Please add one on the{' '}
            <Pressable textDecoration={'underline'} onPress={setTabToProfile}>
              <Text>profile tab</Text>
            </Pressable>
          </Text>
        </Flex>
      )}
      {isChecked && !isInvalid && (
        <>
          <View minH={6} />
          <Flex
            accessibilityRole="alert"
            flexDirection="row"
            bgColor={theme.colors.infoLight}
            p={isDesktop ? 6 : 4}
            alignItems={isDesktop ? 'center' : 'flex-start'}>
            <View alignItems="center" justifyContent="center">
              <SVG
                aria-hidden="true"
                source={Laurel}
                width={isDesktop ? 72 : 44}
                height={isDesktop ? 72 : 44}
              />
              <View
                accessibilityElementsHidden
                overflow="hidden"
                position="absolute">
                <Icon
                  color={'#78B8DE'}
                  size={isDesktop ? 20 : 12}
                  name="info"
                  solid
                />
              </View>
            </View>
            <View minW={isDesktop ? 5 : 3} alignSelf="stretch" />
            <Flex flexShrink={1}>
              <Text
                fontWeight="bold"
                color={theme.colors.info}
                fontSize={isDesktop ? 4 : 3}
                lineHeight={isDesktop ? '26px' : '24px'}>
                You are currently signed up to receive our emails
              </Text>
              <View minH={2} />
              <Text
                color={theme.colors.info}
                fontSize={2}
                lineHeight={isDesktop ? '26px' : '24px'}>
                * To unsubscribe, please uncheck the check box
              </Text>
            </Flex>
          </Flex>
        </>
      )}
    </PanelContainer>
  );
};

export default SubscriptionsModule;
